import BaseAPI from '../api'

const path = 'auth'

export interface PropsInterface {
  email?: string
  ref?: string
  otp?: string
}

export default class LoginApi extends BaseAPI {

  static login(email: string, password: string): Promise<any> {
    return this.api.post(`${path}/login`, { email, password }, {})
      .then((res) => res)
  }

  static resetPassword(password: string, accessToken: string): Promise<any> {
    return this.api.patch(`${path}/password`, { password }, {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
      .then((res) => res)
  }
  static forgotPassword(email: string): Promise<any> {
    return this.api.post(`${path}/forgotpassword`, { email }, {})
      .then((res) => res)
  }
  static getUser(accessToken?: string): Promise<any> {
    return this.api.get(`${path}/profile`, {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
      .then((res) => res)
  }
  static getValidateOTP(props: PropsInterface): Promise<any> {
    return this.api.post(`${path}/validate-otp`, { ...props })
      .then((res) => res)
  }


}
